// @ts-nocheck
import {
    ApiHandlerDiscreteParameter,
    createHandlerChainRunner,
    markSkipOnCompleteIfOnSuccessIsSet,
} from "@insite/client-framework/HandlerCreator";
import { ApiParameter } from "@insite/client-framework/Services/ApiService";
import { getInvoiceByEmail } from "@store/Framework/Services/SendInvoiceEmailService";

export interface SendInvoiceEmailParameter {
    invoiceId: string;
    onSuccess?: () => void;
}

export interface SendInvoiceEmailApiParameter extends ApiParameter {
    invoiceId: string;
}

type HandlerType = ApiHandlerDiscreteParameter<SendInvoiceEmailParameter, SendInvoiceEmailApiParameter, void>;

export const PopulateApiParameter: HandlerType = props => {
    props.apiParameter = {
        invoiceId: props.parameter.invoiceId,
    };
};

export const SendDataToApi: HandlerType = async props => {
    const { apiParameter } = props;
    props.apiResult = await getInvoiceByEmail({ invoiceId: apiParameter.invoiceId });
};

export const ExecuteOnSuccessCallback: HandlerType = props => {
    markSkipOnCompleteIfOnSuccessIsSet(props);
    props.parameter.onSuccess?.();
};

export const chain = [PopulateApiParameter, SendDataToApi, ExecuteOnSuccessCallback];

const sendInvoiceEmail = createHandlerChainRunner(chain, "SendInvoiceEmail");
export default sendInvoiceEmail;
